import React, { Component } from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
} from 'react-router-dom';
import { firebase } from '../firebase';
import MainScreen from './MainScreen';
import * as routes from '../constants/routes';
import SignIn from './SignIn';
import SignUp from './SignUp';
import LandingPage from './LandingPage';
import PrivateRoute from './PrivateRoute';

import { db } from '../firebase';

class App extends Component {
  constructor(props) {
    super(props);
    this.setLoginStatus = this.setLoginStatus.bind(this)

    this.state = {
      loggedIn: localStorage.getItem('astrologerLoggedIn') || false,
      emails: [],
      uids: [],
      superadmin: false,
      adminUid: null,
      adminName: null
    };
  }

  componentWillMount() {
    db.ref('/Admins').once('value').then((snapshot) => {
      var uids = Object.keys(snapshot.val())
      var emails = uids.map((uid) => {
        return snapshot.val()[uid].email
      })
      this.setState({emails: emails})
      this.setState({uids: uids})
    })
  }

  componentDidMount() {
    firebase.auth.onAuthStateChanged(authUser => {
      if(authUser) {
        this.setState({loggedIn: true})
        this.setState({adminUid: authUser.uid})
        this.setState({adminName: authUser.displayName})
      } else {
        this.setState({loggedIn : false})
        this.setState({adminUid: null})
        this.setState({adminName: null})
      }
      authUser && authUser.uid === "jbwERbdL1ORaDBiN0bDugINHG4z1" ? this.setState({ superadmin: true }): this.setState({ superadmin: false })
    });
  }

  setLoginStatus(status) {
    this.setState({ loggedIn: status})
  }

  render() {
    const {loggedIn, emails, uids}= this.state
    return (
      <Router>
        <div>
          <Route exact path="/" render={() => (
            <Redirect to={loggedIn? routes.ACCOUNT: routes.SIGN_IN}/>
          )}/>
          <Route
            exact path={routes.SIGN_IN}
            render={(props) => {
              return !this.state.loggedIn? <SignIn setLoginStatus={this.setLoginStatus} emails={emails} uids={uids} {...props} />:
              <Redirect to={routes.ACCOUNT}/>
            }}
          />
          <PrivateRoute
            exact path={routes.ACCOUNT}
            component={MainScreen}
            loggedIn={this.state.loggedIn}
            superadmin = {this.state.superadmin}
            adminUid = {this.state.adminUid}
            adminName = {this.state.adminName}
          />
           <Route
            exact path={routes.SIGNUP}
            component={SignUp}
          />
            <Route
            exact path={routes.LANDINGPAGE}
            component={LandingPage}
          />
        </div>
      </Router>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/Components/App.js